var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 3.5,
    stroke: "#8B93A7",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 17.5H19C18.5 17.5 17.5 17.8 17.5 19C17.5 20.2 17.5 31.5 17.5 37C17.5 37.5 18 38.5 20 38.5C22 38.5 32.1667 38.5 37 38.5C37.5 38.5 38.5 38 38.5 36C38.5 34 38.5 29.8333 38.5 28",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 34.4171L23.7376 28.6992C24.1727 28.3004 24.8371 28.2893 25.2852 28.6735L32.6667 35.0004",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3359 32.0833L33.1205 29.2987C33.531 28.8882 34.1809 28.842 34.6454 29.1904L38.5026 32.0833",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5859 24.5V17.5",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6641 20.4167L35.5807 17.5L38.4974 20.4167",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAvatar);
export default __webpack_public_path__ + "static/media/upload-avatar.940c248bd40230bc328c18f34080d5b3.svg";
export { ForwardRef as ReactComponent };